import React, { Component } from 'react';
import Group_Cell from './Group_Cell';
import Top_Bar from '../Part_Sample/Top_Bar';

export default class Groups extends Component {
	constructor(props) {
		super(props);
		// Retain scroll position of groups screen
		this.state = {
			is_show_group_edit: false,
			scroll_top: 0,
		}
		// Add groups ref for retaining scroll position
		this.groups_ref = React.createRef();
	}

	componentDidMount = () => {
		if (this.props.param.groups_scroll_top != null) {
			this.groups_ref.current.scrollTop = this.props.param.groups_scroll_top;
		}
	}

	handleAddGroup = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		// pass in all the groups information
		this.props.content_handler('Group_Edit', { group: null, group_id: null, from: 'Groups', groups: this.props.param.groups })
	}

	handleOnScroll = () => {
		this.setState({
			scroll_top: this.groups_ref.current.scrollTop,
		})
	}

	render() {
		let style = {
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('group')}
						right_button_type={this.props.receiver.active_controller.user_class == 'Admin' ? 'add' : null}
						handleRightButton={this.props.receiver.active_controller.user_class == 'Admin' ? this.handleAddGroup : null}
					/>
					<div style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: this.props.width - 10 }}>
						<div ref={this.groups_ref} className='noScrollBar' onScroll={this.handleOnScroll} style={{ height: this.props.height - 123, overflow: 'auto' }}>
							{Object.keys(this.props.param.groups).map((key_name, i) => {
								let group_info = this.props.param.groups[key_name];
								//Will only show groups which user has access to at least 1 mp
								let has_accessible_points = true;
								let accessible_points = this.props.receiver.active_controller.auth.points;
								if (accessible_points == null || accessible_points == 'null') accessible_points = {};

								let group_points = [];
								if (group_info.hasOwnProperty('mp')) group_points = group_info.mp;

								if (this.props.receiver.active_controller.user_class != 'Admin') {
									has_accessible_points = false;
									for (let key in group_points) { //For each mp in the group
										if (accessible_points.hasOwnProperty(group_points[key])) { //check if user has access to mp
											if (accessible_points[group_points[key]]) {
												has_accessible_points = true;
												break;
											}
										}
									}
								}

								if (has_accessible_points) {
									return (
										<Group_Cell
											group_info={group_info}
											groups={this.props.param.groups}
											id={key_name}
											receiver={this.props.receiver}
											content_handler={this.props.content_handler}
											from={"Groups"}
											groups_scroll_top={this.state.scroll_top}
										/>
									)
								}
							})}
							<div> &nbsp;&nbsp;&nbsp;</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}